module.exports = __webpack_public_path__ + "static/media/diamond.41a3b5d5.svg";